export function getRsvpFormHeight(extraHeight = 0): string {
  const form = document.getElementById('rsvp-form') as HTMLElement
  return form.getBoundingClientRect().height + extraHeight + 'px'
}
